import React, { useState, useEffect } from "react";

import { isEqual } from "lodash";
import MuiTextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

export const usStatesList = [
  {
    name: "Alabama  (AL)",
    abbreviation: "AL",
  },
  {
    name: "Alaska  (AK)",
    abbreviation: "AK",
  },
  // {
  //   name: "American Samoa",
  //   abbreviation: "AS",
  // },
  {
    name: "Arizona  (AZ)",
    abbreviation: "AZ",
  },
  {
    name: "Arkansas  (AR)",
    abbreviation: "AR",
  },
  {
    name: "California  (CA)",
    abbreviation: "CA",
  },
  {
    name: "Colorado  (CO)",
    abbreviation: "CO",
  },
  {
    name: "Connecticut  (CT)",
    abbreviation: "CT",
  },
  {
    name: "Delaware  (DE)",
    abbreviation: "DE",
  },
  {
    name: "District Of Columbia  (DC)",
    abbreviation: "DC",
  },
  // {
  //   name: "Federated States Of Micronesia",
  //   abbreviation: "FM",
  // },
  {
    name: "Florida  (FL)",
    abbreviation: "FL",
  },
  {
    name: "Georgia  (GA)",
    abbreviation: "GA",
  },
  {
    name: "Guam  (GU)",
    abbreviation: "GU",
  },
  {
    name: "Hawaii  (HI)",
    abbreviation: "HI",
  },
  {
    name: "Idaho  (ID)",
    abbreviation: "ID",
  },
  {
    name: "Illinois  (IL)",
    abbreviation: "IL",
  },
  {
    name: "Indiana  (IN)",
    abbreviation: "IN",
  },
  {
    name: "Iowa  (IA)",
    abbreviation: "IA",
  },
  {
    name: "Kansas  (KS)",
    abbreviation: "KS",
  },
  {
    name: "Kentucky  (KY)",
    abbreviation: "KY",
  },
  {
    name: "Louisiana  (LA)",
    abbreviation: "LA",
  },
  {
    name: "Maine  (ME)",
    abbreviation: "ME",
  },
  // {
  //   name: "Marshall Islands",
  //   abbreviation: "MH",
  // },
  {
    name: "Maryland  (MD)",
    abbreviation: "MD",
  },
  {
    name: "Massachusetts  (MA)",
    abbreviation: "MA",
  },
  {
    name: "Michigan  (MI)",
    abbreviation: "MI",
  },
  {
    name: "Minnesota  (MN)",
    abbreviation: "MN",
  },
  {
    name: "Mississippi  (MS)",
    abbreviation: "MS",
  },
  {
    name: "Missouri  (MO)",
    abbreviation: "MO",
  },
  {
    name: "Montana  (MT)",
    abbreviation: "MT",
  },
  {
    name: "Nebraska  (NE)",
    abbreviation: "NE",
  },
  {
    name: "Nevada  (NV)",
    abbreviation: "NV",
  },
  {
    name: "New Hampshire  (NH)",
    abbreviation: "NH",
  },
  {
    name: "New Jersey  (NJ)",
    abbreviation: "NJ",
  },
  {
    name: "New Mexico  (NM)",
    abbreviation: "NM",
  },
  {
    name: "New York  (NY)",
    abbreviation: "NY",
  },
  {
    name: "North Carolina  (NC)",
    abbreviation: "NC",
  },
  {
    name: "North Dakota  (ND)",
    abbreviation: "ND",
  },
  // {
  //   name: "Northern Mariana Islands",
  //   abbreviation: "MP",
  // },
  {
    name: "Ohio  (OH)",
    abbreviation: "OH",
  },
  {
    name: "Oklahoma  (OK)",
    abbreviation: "OK",
  },
  {
    name: "Oregon  (OR)",
    abbreviation: "OR",
  },
  // {
  //   name: "Palau",
  //   abbreviation: "PW",
  // },
  {
    name: "Pennsylvania  (PA)",
    abbreviation: "PA",
  },
  {
    name: "Puerto Rico  (PR)",
    abbreviation: "PR",
  },
  {
    name: "Rhode Island  (RI)",
    abbreviation: "RI",
  },
  {
    name: "South Carolina  (SC)",
    abbreviation: "SC",
  },
  {
    name: "South Dakota  (SD)",
    abbreviation: "SD",
  },
  {
    name: "Tennessee  (TN)",
    abbreviation: "TN",
  },
  {
    name: "Texas  (TX)",
    abbreviation: "TX",
  },
  {
    name: "Utah  (UT)",
    abbreviation: "UT",
  },
  {
    name: "Vermont  (VT)",
    abbreviation: "VT",
  },
  {
    name: "Virgin Islands  (VI)",
    abbreviation: "VI",
  },
  {
    name: "Virginia  (VA)",
    abbreviation: "VA",
  },
  {
    name: "Washington  (WA)",
    abbreviation: "WA",
  },
  {
    name: "West Virginia  (WV)",
    abbreviation: "WV",
  },
  {
    name: "Wisconsin  (WI)",
    abbreviation: "WI",
  },
  {
    name: "Wyoming  (WY)",
    abbreviation: "WY",
  },
];

function getOptionData(text) {
  if (!text) return null;
  if (text.length === 2) {
    const state = usStatesList.find(
      (state) => state.abbreviation.toLowerCase() === text.toLowerCase()
    );
    return state;
  }
  if (text.length > 2) {
    return usStatesList.find((state) =>
      state.name.toLowerCase().includes(text.toLowerCase())
    );
  }
}

export const AutocompleteUSStates = (props) => {
  const [prevValue, setPrevValue] = useState("");
  return (
    <Autocomplete
      {...props}
      autoComplete={true}
      autoSelect={true}
      options={usStatesList}
      getOptionLabel={(option) => option.name || ""}
      getOptionSelected={(option, value) => {
        return isEqual(option, value);
      }}
      renderInput={(params) => {
        function tryAutoSelect(e) {
          const optionData = getOptionData(e.target.value);
          if (optionData) {
            // autoselect (for browser autofill and paste)
            params.inputProps.onChange(e);
            props.onChange(optionData);
            setTimeout(() => {
              $(
                `.MuiAutocomplete-option:contains("${optionData.name}")`
              ).trigger("click");
              setPrevValue(e.target.value); // set after trigger "click"
            }, 0);
          } else {
            setPrevValue(e.target.value);
            params.inputProps.onChange(e);
          }
        }
        return (
          <MuiTextField
            label={params.inputProps.value ? "" : "Select state"} // hide label if value is selected
            variant={props.variant}
            {...params}
            inputProps={{
              ...params.inputProps,
              name: "state",
              id: "state",
              onBlur: tryAutoSelect,
              onChange: (e) => {
                // if diff === 1, then it's typed input and dont check for autoselect
                if (Math.abs(e.target.value?.length - prevValue.length) > 1) {
                  tryAutoSelect(e);
                } else {
                  setPrevValue(e.target.value);
                  params.inputProps.onChange(e);
                }
              },
            }}
            InputLabelProps={{ shrink: false }}
          />
        );
      }}
      onChange={(_, data) => {
        setPrevValue(data?.name || "");
        props.onChange(data);
      }}
    />
  );
};

// export default AutocompleteUSStates;
